module.exports = __webpack_public_path__ + "img/tab02.8877969e.jpg";